'use strict';

var angularModule = angular.module('t2g.common.filter', [
  require('./dateFilter').name,
  require('./momentFilter').name,
  require('./orFilter').name,
  require('./propsFilter').name,
  require('./orFilterNew').name,
  require('./truncateFilter').name,
  require('./uniqueFilter').name,
]);

module.exports = angularModule;



// WEBPACK FOOTER //
// ./src/app/common/filter/index.js